export const transactions = {
  latest_transactions: [
    {
      account_id: "bLkJajE8xliPWD4oGqd4HXdzLZQXzKtoqyrgP",
      account_owner: null,
      amount: 5.4,
      authorized_date: "2023-03-30",
      authorized_datetime: null,
      category: ["Travel", "Taxi"],
      category_id: "22016000",
      check_number: null,
      date: "2023-03-31",
      datetime: null,
      iso_currency_code: "USD",
      location: {
        address: null,
        city: null,
        country: null,
        lat: null,
        lon: null,
        postal_code: null,
        region: null,
        store_number: null,
      },
      merchant_name: "Uber",
      name: "Uber 063015 SF**POOL**",
      payment_channel: "online",
      payment_meta: {
        by_order_of: null,
        payee: null,
        payer: null,
        payment_method: null,
        payment_processor: null,
        ppd_id: null,
        reason: null,
        reference_number: null,
      },
      pending: false,
      pending_transaction_id: null,
      personal_finance_category: null,
      transaction_code: null,
      transaction_id: "nylzXJEB5PTkWwK1GpLKilkpWyNvJ4t3zgQRw",
      transaction_type: "special",
      unofficial_currency_code: null,
    },
    {
      account_id: "mmRke9yr5NszVgqLEW1qSkzWqDXkWNF4Jw8R8",
      account_owner: null,
      amount: 25,
      authorized_date: "2023-03-30",
      authorized_datetime: null,
      category: ["Payment", "Credit Card"],
      category_id: "16001000",
      check_number: null,
      date: "2023-03-31",
      datetime: null,
      iso_currency_code: "USD",
      location: {
        address: null,
        city: null,
        country: null,
        lat: null,
        lon: null,
        postal_code: null,
        region: null,
        store_number: null,
      },
      merchant_name: null,
      name: "CREDIT CARD 3333 PAYMENT *//",
      payment_channel: "other",
      payment_meta: {
        by_order_of: null,
        payee: null,
        payer: null,
        payment_method: null,
        payment_processor: null,
        ppd_id: null,
        reason: null,
        reference_number: null,
      },
      pending: false,
      pending_transaction_id: null,
      personal_finance_category: null,
      transaction_code: null,
      transaction_id: "vxdPrRXpqLCjA84lEWG4SEjWk1r53JTv8V1mb",
      transaction_type: "special",
      unofficial_currency_code: null,
    },
    {
      account_id: "9P1AvwrG8eClRBa8NKxaTxRk1yexkLFqDbMzb",
      account_owner: null,
      amount: 500,
      authorized_date: null,
      authorized_datetime: null,
      category: ["Shops", "Sporting Goods"],
      category_id: "19046000",
      check_number: null,
      date: "2023-04-09",
      datetime: null,
      iso_currency_code: "USD",
      location: {
        address: null,
        city: null,
        country: null,
        lat: null,
        lon: null,
        postal_code: null,
        region: null,
        store_number: null,
      },
      merchant_name: null,
      name: "Madison Bicycle Shop",
      payment_channel: "in store",
      payment_meta: {
        by_order_of: null,
        payee: null,
        payer: null,
        payment_method: null,
        payment_processor: null,
        ppd_id: null,
        reason: null,
        reference_number: null,
      },
      pending: false,
      pending_transaction_id: null,
      personal_finance_category: null,
      transaction_code: null,
      transaction_id: "Dgb5rw7x8WuNXQ5dEGo5hVzl3mpAD8f46GJD5",
      transaction_type: "place",
      unofficial_currency_code: null,
    },
    {
      account_id: "9P1AvwrG8eClRBa8NKxaTxRk1yexkLFqDbMzb",
      account_owner: null,
      amount: 500,
      authorized_date: null,
      authorized_datetime: null,
      category: ["Food and Drink", "Restaurants", "Fast Food"],
      category_id: "13005032",
      check_number: null,
      date: "2023-04-09",
      datetime: null,
      iso_currency_code: "USD",
      location: {
        address: null,
        city: null,
        country: null,
        lat: null,
        lon: null,
        postal_code: null,
        region: null,
        store_number: null,
      },
      merchant_name: "KFC",
      name: "KFC",
      payment_channel: "in store",
      payment_meta: {
        by_order_of: null,
        payee: null,
        payer: null,
        payment_method: null,
        payment_processor: null,
        ppd_id: null,
        reason: null,
        reference_number: null,
      },
      pending: false,
      pending_transaction_id: null,
      personal_finance_category: null,
      transaction_code: null,
      transaction_id: "VdP5Xg4lWQtXwl5ayr35SLoM36AZ8RuqKNE1J",
      transaction_type: "place",
      unofficial_currency_code: null,
    },
    {
      account_id: "9P1AvwrG8eClRBa8NKxaTxRk1yexkLFqDbMzb",
      account_owner: null,
      amount: 2078.5,
      authorized_date: null,
      authorized_datetime: null,
      category: ["Payment", "Rent"],
      category_id: "16002000",
      check_number: null,
      date: "2023-04-09",
      datetime: null,
      iso_currency_code: "USD",
      location: {
        address: null,
        city: null,
        country: null,
        lat: null,
        lon: null,
        postal_code: null,
        region: null,
        store_number: null,
      },
      merchant_name: null,
      name: "AUTOMATIC PAYMENT - THANK",
      payment_channel: "online",
      payment_meta: {
        by_order_of: null,
        payee: null,
        payer: null,
        payment_method: null,
        payment_processor: null,
        ppd_id: null,
        reason: null,
        reference_number: null,
      },
      pending: false,
      pending_transaction_id: null,
      personal_finance_category: null,
      transaction_code: null,
      transaction_id: "wdajz5EgKpt7xeVRGqnVfZ7nE1Wr3LCEWKmw7",
      transaction_type: "special",
      unofficial_currency_code: null,
    },
    {
      account_id: "9P1AvwrG8eClRBa8NKxaTxRk1yexkLFqDbMzb",
      account_owner: null,
      amount: 500,
      authorized_date: null,
      authorized_datetime: null,
      category: ["Payment", "Rent"],
      category_id: "16002000",
      check_number: null,
      date: "2023-04-10",
      datetime: null,
      iso_currency_code: "USD",
      location: {
        address: null,
        city: null,
        country: null,
        lat: null,
        lon: null,
        postal_code: null,
        region: null,
        store_number: null,
      },
      merchant_name: null,
      name: "Tectra Inc",
      payment_channel: "in store",
      payment_meta: {
        by_order_of: null,
        payee: null,
        payer: null,
        payment_method: null,
        payment_processor: null,
        ppd_id: null,
        reason: null,
        reference_number: null,
      },
      pending: false,
      pending_transaction_id: null,
      personal_finance_category: null,
      transaction_code: null,
      transaction_id: "X475NwPz8MfBV1lQboalCQMwdml3J5F1e8LZA",
      transaction_type: "special",
      unofficial_currency_code: null,
    },
    {
      account_id: "bLkJajE8xliPWD4oGqd4HXdzLZQXzKtoqyrgP",
      account_owner: null,
      amount: 6.33,
      authorized_date: "2023-04-12",
      authorized_datetime: null,
      category: ["Travel", "Taxi"],
      category_id: "22016000",
      check_number: null,
      date: "2023-04-13",
      datetime: null,
      iso_currency_code: "USD",
      location: {
        address: null,
        city: null,
        country: null,
        lat: null,
        lon: null,
        postal_code: null,
        region: null,
        store_number: null,
      },
      merchant_name: "Uber",
      name: "Uber 072515 SF**POOL**",
      payment_channel: "online",
      payment_meta: {
        by_order_of: null,
        payee: null,
        payer: null,
        payment_method: null,
        payment_processor: null,
        ppd_id: null,
        reason: null,
        reference_number: null,
      },
      pending: false,
      pending_transaction_id: null,
      personal_finance_category: null,
      transaction_code: null,
      transaction_id: "GW95GkZjQqI7a356KAn5foRrWmj6DxuGbRovX",
      transaction_type: "special",
      unofficial_currency_code: null,
    },
    {
      account_id: "9P1AvwrG8eClRBa8NKxaTxRk1yexkLFqDbMzb",
      account_owner: null,
      amount: 500,
      authorized_date: null,
      authorized_datetime: null,
      category: ["Travel", "Airlines and Aviation Services"],
      category_id: "22001000",
      check_number: null,
      date: "2023-04-15",
      datetime: null,
      iso_currency_code: "USD",
      location: {
        address: null,
        city: null,
        country: null,
        lat: null,
        lon: null,
        postal_code: null,
        region: null,
        store_number: null,
      },
      merchant_name: "United Airlines",
      name: "United Airlines",
      payment_channel: "in store",
      payment_meta: {
        by_order_of: null,
        payee: null,
        payer: null,
        payment_method: null,
        payment_processor: null,
        ppd_id: null,
        reason: null,
        reference_number: null,
      },
      pending: false,
      pending_transaction_id: null,
      personal_finance_category: null,
      transaction_code: null,
      transaction_id: "ZPQ5xj7dqLCbEqKykBlkfGJ1BAKWeKUJ6dja6",
      transaction_type: "special",
      unofficial_currency_code: null,
    },
  ],
};
